import apiClient from './apiClient';

const emailService = {
  // Enviar email
  sendEmail: async (emailData) => {
    try {
      console.log('Sending email data to backend:', JSON.stringify(emailData, null, 2));
      const response = await apiClient.post('/send-email', emailData);
      console.log('Response from backend:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error sending email:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

 
  
};

export default emailService;